<template>
  <div v-if="visible" class="site-banner">
    <span class="text">
      <p>
        We are pleased to let you know that Safety Management Services, Inc.
        (SMS™) has been acquired by
        <a href="https://www.jensenhughes.com/" target="_blank" rel="noopener">
          <b><u>Jensen Hughes,</u></b>
        </a>
        the global leader in fire & life safety, security and risk-based
        engineering and consulting.
        <a
          href="https://www.jensenhughes.com/insights/jensen-hughes-acquires-safety-management-services-inc"
          target="_blank"
          rel="noopener"
        >
          <b><u>READ MORE</u></b>
        </a>
      </p>
    </span>

    <button class="close-btn" @click="visible = false">×</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true,
    };
  },
};
</script>

<style scoped>
.site-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  background-color: rgb(170, 34, 44); /* solid red background */
  color: white; /* text color */

  padding: 12px 40px; /* space for X button */
}

.text {
  color: white; /* ensures text stays white */
  font-size: 1rem;
}

.close-btn {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);

  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  line-height: 1;
  color: white; /* X button color */
}

.close-btn:hover {
  opacity: 0.6;
}
</style>
